import { api } from '../../Config';
import RefreshToken from '../../RefreshToken';
import * as msg from '../reusables/toast/Toast';
import Style from './Style.module.css';
import { useEffect, useState } from 'react';
import { Container, Card, CardContent, Grid, IconButton, Tooltip, Fab } from '@material-ui/core';
import {Edit, Close, Add, FileCopy} from '@material-ui/icons';
import Authenticated from '../reusables/authenticated/Authenticated';
import PageTitle from '../reusables/pageTitle/PageTitle';
import Modal from '../reusables/modal/Modal';
import Register from './register/Register';
import Loading from '../reusables/loading/Loading';
import NoDataToDisplay from '../reusables/noDataToDisplay/NoDataToDisplay';

function PhishingCampaign() {
    const [element, setElement] = useState('');
    const [elements, setElements] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [registering, setRegistering] = useState(false);
    const [processing, setProcessing] = useState(true);
    const [duplicating, setDuplicating] = useState(false);

    useEffect(() => getElements(), []);

    function getElements(){
        setProcessing(true)
        fetch(api.urlPhishingCampaign, {
            headers: {'Authorization': `Bearer ${localStorage.getItem("accessToken")}`}
        })
        .then((data) => {
            if (data.status === 200){
                data.json().then((data) => {
                    setElements(data)
                    setProcessing(false)
                })
            } else if (data.status === 401) {
                RefreshToken()
                getElements()
            } else {
                msg.error('Se ha producido un error')
            }
        })
        .catch(console.log)
    }

    function hideModal(){
        setRegistering(false)
        setDeleting(false)
    }

    function confirmDelete(e){
        setDeleting(true)
        setElement(e)
    }

    function del(){
        setProcessing(true)
        fetch(api.urlPhishingCampaign+element.id, {
            method: 'delete',
            headers: {'Authorization': `Bearer ${localStorage.getItem("accessToken")}`}
        })
        .then((data) => {
            if (data.status === 204){
                setDeleting(false)
                getElements()
                setProcessing(false)
                msg.success('Eliminación exitosa')
            } else if (data.status === 401) {
                RefreshToken()
                del()
            } else {
                msg.error('Se ha producido un error')
            }
        })
        .catch(console.log)
    }

    function update(e){
        setRegistering(true)
        setElement(e)
    }

    function register(){
        setRegistering(true)
        setElement('')
    }

    function duplicate(e){
        setElement(e)
        setDuplicating(true)
        fetch(api.urlCopyCampaign, {
            method: 'post',
            headers: {'Authorization': `Bearer ${localStorage.getItem("accessToken")}`, 'Content-Type': 'application/json'},
            body: JSON.stringify({'campaign_id' : e.id})
        })
        .then((data) => {
            if (data.status === 200){
                setDuplicating(false)
                getElements()
                msg.success('Duplicación exitosa')
            } else if (data.status === 401) {
                RefreshToken()
                duplicate(e)
            } else {
                msg.error('Se ha producido un error')
            }
        })
        .catch(console.log)
    }

    return (
        <Authenticated>
            <br/><br/><br/>
            <Container maxWidth="lg">
                <PageTitle primary="Campa&ntilde;as de phishing" secondary="Cat&aacute;logo de plantillas para campa&ntilde;as de phishing"/>
                <br/>
                {processing && !registering && !deleting ?
                    <Loading variant="list" column={2} height={50}/>
                :
                    elements.length > 0 ?
                        <Grid container spacing={3}>
                            {elements.map((item, index) => (
                                <Grid key={index} item xs={12} md={6}>
                                    <Card className={Style.item}>
                                        <CardContent>
                                            <Grid container spacing={3}>
                                                <Grid item xs={7}>
                                                    <div className={Style.title}>{item.name}</div>
                                                    <div className={Style.detail}>{item.subject}</div>
                                                </Grid>
                                                <Grid item xs={5} className={Style.options}>
                                                    <Tooltip title="Duplicar" placement="left" arrow>
                                                        <IconButton onClick={() => duplicate(item)} className={duplicating && element.id === item.id ? Style.duplicating : ''}>
                                                            <FileCopy fontSize="small"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Editar" placement="left" arrow>
                                                        <IconButton onClick={() => update(item)}>
                                                            <Edit fontSize="small"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Eliminar" placement="left" arrow>
                                                        <IconButton onClick={() => confirmDelete(item)}>
                                                            <Close fontSize="small"/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    : <NoDataToDisplay/>}
            </Container>
            <br/><br/>
            <Tooltip title="Nueva campa&ntilde;a" placement="left" arrow>
                <Fab onClick={register} color="secondary">
                    <Add fontSize="large" />
                </Fab>
            </Tooltip>
            {registering ? <Register element={element} getElements={getElements} hideModal={hideModal}/> : <></>}
            {deleting ?
                <Modal
                    title="Confirmaci&oacute;n"
                    content="¿ Deseas realmente continuar con la eliminaci&oacute;n ?"
                    secondaryActionName="Cancelar"
                    primaryActionName="Continuar"
                    secondaryAction={hideModal}
                    primaryAction={del}
                    primaryActionDisabled={false}
                    processing={processing}/>
            : <></>}
        </Authenticated>
    );
}

export default PhishingCampaign;